<!-- .block-categories -->
<div class="block block--highlighted block-categories block-categories--layout--{{ layout }}">
    <div class="container">
        <app-block-header [header]="header"></app-block-header>

        <div class="block-categories__list" >
            <div class="row">
                <div class="col-md-4 my-4 ng-star-inserted" *ngFor="let category of categories">
                    <div [routerLink]="root.category(category)" class="h-100 main-wrapper mouse" tabindex="0"><img alt="#"
                            class="bg-img img-fluid b-rad h-100" [src]="category.image">
                    </div>
                </div>
            </div>
            <!-- <div *ngFor="let category of categories" class="block-categories__item category-card category-card--layout--{{ layout }}">
                <div class="category-card__body">
                    <div class="category-card__image">
                        <a [routerLink]="root.category(category)"><img [src]="category.image" alt=""></a>
                    </div>
                    <div class="category-card__content">
                        <div class="category-card__name">
                            <a [routerLink]="root.category(category)">{{ category.name }}</a>
                        </div>
                        <ul class="category-card__links">
                            <li *ngFor="let category of category.children">
                                <a [routerLink]="root.category(category)">{{ category.name }}</a>
                            </li>
                        </ul>
                        <div class="category-card__all">
                            <a [routerLink]="root.category(category)">Show All</a>
                        </div>
                        <div class="category-card__products">
                            {{ category.items }}
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
<!-- .block-categories / end -->